module.exports = __webpack_public_path__ + "img/carousel-6.81f6375c.png";